var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 19,
    viewBox: "0 0 33 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0297 1.41385C0.069725 2.37383 0.069725 3.93045 1.0297 4.89043L13.0564 16.9054C14.9768 18.8239 18.0886 18.8231 20.008 16.9037L32.0301 4.88158C32.9901 3.9216 32.9901 2.36498 32.0301 1.405C31.07 0.444778 29.5135 0.444778 28.5535 1.405L18.2639 11.6946C17.3036 12.6546 15.7473 12.6546 14.7873 11.6946L4.50628 1.41385C3.5463 0.453875 1.98968 0.453875 1.0297 1.41385Z",
    fill: "#353A47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDownArrow);
export default __webpack_public_path__ + "static/media/card-down-arrow.1ff05c13ad888a46930d5d9b458e66e4.svg";
export { ForwardRef as ReactComponent };